<template lang="pug">
div.pl-4.align-self-center
  v-icon.pr-1(color = 'orange' x-small) far fa-exclamation-circle
  span {{ $t('billingPage.notPayed') }}:
  span.pl-1.font-weight-bold.value {{getUnPaidValue}}
  v-icon.pl-4(color = 'green' x-small) far fa-check-circle
  span.pl-1 {{ $t('billingPage.fullyPayed') }}:
  span.pl-1.font-weight-bold.value {{getFullyPaidValue}}
  v-icon.pl-4(color = 'orange' x-small) far fa-exclamation-triangle
  span.pl-1 {{ $t('billingPage.partiallyPayed') }}:
  span.pl-1.font-weight-bold.value {{getPartiallyPaidValue}}
  v-icon.pl-4(color = 'red' x-small) far fa-exclamation-triangle
  span.pl-1 {{ $t('billingPage.notPayedAfterExpiration') }}:
  span.pl-1.font-weight-bold.value {{getUnPaidAfterExpirationValue}}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Invoice} from "@/model/billing/Invoice";
import {InvoicePaymentStatus} from "@/types/enums";
import {IStatusPanelParams, ModelUpdatedEvent, RowNode} from "ag-grid-community";

@Component({
  components: {}
})
export default class BillingCustomStatusPanel extends Vue {
  private invoiceList: Invoice[] = []
  private params!: IStatusPanelParams

  get getUnPaidValue() {
    return this.invoiceList.filter((item: Invoice) => item.paymentStatus === InvoicePaymentStatus.notPaid).length
  }

  get getFullyPaidValue() {
    return this.invoiceList.filter((item: Invoice) => item.paymentStatus === InvoicePaymentStatus.fullyPaid).length
  }

  get getPartiallyPaidValue() {
    return this.invoiceList.filter((item: Invoice) => item.paymentStatus === InvoicePaymentStatus.partiallyPaid).length
  }

  get getUnPaidAfterExpirationValue() {
    return this.invoiceList.filter((item: Invoice) => item.paymentStatus === InvoicePaymentStatus.notPayedAfterExpiration).length
  }

  mounted() {
    this.params.api.addEventListener('modelUpdated' ,(evt: ModelUpdatedEvent) => {
      let data: Invoice[] = []
      evt.api.forEachNodeAfterFilter((params: RowNode) => {
        data.push(params.data)
      })
      this.invoiceList = data
    })
  }
}
</script>

<style lang="stylus" scoped>
.value
  color black
</style>